<template>
<b-container fluid style="background-color: #C4E1F0;">
<b-row class="text-center">
<b-col cols="1" md="2" lg="4"></b-col>
<b-col cols="10" md="8" lg="4" v-if="!show && !submitted" class="other">
    <b-spinner style="width: 5rem; height: 5rem; color:#51748b; " label="Large Spinner" ></b-spinner>
</b-col>
<b-col cols="10" md="8" lg="4"  class="mb-5 mt-5" v-if="show && !submitted" style="background-color:white; border-radius: 20px">
    <br>
    <b style="font-size:14pt;">Service Request</b>
    <div style="font-size:11pt;margin-top:10pt">Please use this form only for non-emergency situations.</div>
    <div v-if="marketphone" style="font-size:11pt;"> If this is an emergency, please call {{marketphone}}.</div>
    <div v-if="!marketphone" style="font-size:11pt;"> If this is an emergency, please refer to your arrival instructions for contact information.</div>
    <div md="8" style="font-size:10pt; margin-top: 10px; color: red">
    An emergency is considered, but not limited to; water leak, gas odor, clogged toilet in a one bathroom apartment, Internet outage,
    no heat when the temperature is less than 60, no air conditioning when
    the outside temperature is greater than 80 or if you are locked out of your apartment.
    </div>
    <br>
    <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group
            id="input-group-1"
            label="Name:"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-input
            id="input-3"
            v-model="form.requester"
            size="sm"
            class="w-50"
            required
            ></b-form-input>
        </b-form-group>         
        <b-form-group
            id="input-group-1"
            label="Location:"
            label-for="input-2"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-2"
            v-model="form.location"
            :options="locations"
            class="w-25"
            size="sm"
            required
            ></b-form-select>
        </b-form-group>        
        <b-form-group
            id="input-group-1"
            label="Work Type:"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-3"
            v-model="form.worktype"
            :options="worktypes"
            class="w-50"
            size="sm"
            required
            ></b-form-select>
        </b-form-group>   
        <b-form-group
            id="input-group-1"
            label="Do we have permission to enter your unit to perform the requested service?"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-3"
            v-model="form.permission"
            :options="yn"
            size="sm"
            required
            ></b-form-select>
            <b v-if="form.permission == 'Yes'" style="font-weight:normal !important; color: red; font-size: 14px">Please ensure all residents are aware that this request has been submitted and a maintenance technician will enter to complete your request.</b>
            <b v-if="form.permission == 'No'" style="font-weight:normal !important; color: red; font-size: 14px">A member of our team will reach out within 24-48 business hours to schedule service.</b>
        </b-form-group>
        <b-form-group
            id="input-group-1"
            label="Has the alarm code changed?"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-3"
            v-model="form.alarm"
            :options="yn"
            size="sm"
            required
            ></b-form-select>
        </b-form-group>
        <b-form-group
            v-if="form.alarm == 'Yes'"
            id="input-group-1"
            label="New alarm code:"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-input
            id="input-3"
            v-model="form.alarmcode"
            size="sm"
            class="w-30"
            :required="form.alarm=='Yes' ? true : false"
            ></b-form-input>
        </b-form-group>                
        <b-form-group
            id="input-group-1"
            label="Do you have a pet?"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-3"
            v-model="form.pet"
            :options="yn"
            size="sm"
            required
            ></b-form-select>
            <b v-if="form.pet == 'Yes'" style="font-weight:normal !important; color: red; font-size: 14px">Please ensure your pet is crated or secured in another room.</b>
        </b-form-group>         
        <b-form-group
            id="input-group-1"
            label="Issue Description:"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-input
            id="input-3"
            v-model="form.description"
            size="sm"
            required
            ></b-form-input>
        </b-form-group> 
        <b-form-group
            id="input-group-1"
            label="Issue Details:"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-textarea
            id="input-3"
            v-model="form.details"
            rows=8
            required
            ></b-form-textarea>
        </b-form-group>
      <b-form-group
            id="input-group-1"
            label="Do you or anyone in your home have a fever, cough, shortness of breath, chills, headache, sore throat, or new loss of taste/smell?"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-3"
            v-model="form.covid1"
            :options="yn"
            size="sm"
            required
            ></b-form-select>
        </b-form-group>
        <b-form-group
            id="input-group-1"
            label="Have you or anyone in your home been in contact with anyone with a confirmed diagnosis of Covid-19 in the last 14 days?"
            label-for="input-3"
            label-align="left"
            style="text-align: left"
        >
            <b-form-select
            id="input-3"
            v-model="form.covid2"
            :options="yn"
            size="sm"
            required
            ></b-form-select>
        </b-form-group>                                   
        <b-button type="submit" style="background-color:#51748b" class="mr-2 mb-4 mt-2" size="sm">
         <b-spinner small v-show="loading"></b-spinner>
             Submit
        </b-button>
        <b-button type="reset" style="background-color:#51748b" class="ml-2 mb-4 mt-2" size="sm">Reset</b-button>
    </b-form>
</b-col>
<b-col cols="10" md="8" lg="4"  v-if="!show && submitted" class="other" >
Thank you for submitting your request. A representative<br><br>has been notified
and will be contacting you soon.<br>
</b-col>
<b-col cols="1" md="2" lg="4"></b-col>
</b-row>
</b-container>
</template>

<script>
const axios = require("axios");
  export default {
    data() {
      return {
        form: {
            priority: 4,
            requester: null,
            location: null,
            worktype: null,
            permission: null,
            alarm: null,
            alarmcode: null,
            pet: null,
            description: null,
            details: null,
            covid1: null,
            covid2: null
        },
        locations: [],
        marketphone: null,
        reservename: null,
        worktypes: [],
        yn: [{value: "Yes", text:"Yes"},{value: "No", text:"No"}],
        resid: null,
        show: false,
        submitted: false,
        error: false,
        loading: false
      }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault()
            this.form.resid = this.resid
            this.submitData();
            //console.log(JSON.stringify(this.form))
        },
        onReset(event) {
            event.preventDefault()
            this.clearForm();
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        },
        clearForm(){
            // Reset our form values
            Object.keys(this.form).forEach(key => { 
                this.form[key] = null
            })
        },
        async loadData() {
            let valid = 0
            try {
                const response = await axios.post(process.env.VUE_APP_APIPARAMS, {"value":this.resid})
                //console.log(response)
                
                await response.data.Table1.map(item => {
                    if (item.Type == 'location') {
                        this.locations.push({value: item.ID, text: item.Value});
                    } else if (item.Type == 'workordertype') {
                        this.worktypes.push({value: item.ID, text: item.Value});
                    } else if (item.Type == 'marketphone' && item.Value.length > 1) {
                        this.marketphone = item.Value
                    } else if (item.Type == 'reservename') {
                        valid = 1
                        this.reservename = item.Value
                    }                     
                })                
                if(valid)
                {
                    this.show = true;
                }
                else
                {
                    await axios.post(process.env.VUE_APP_ERROR, {"system": "Work Orders", "message": "Reservation not found in the system.", "email": 'none'}) 
                    this.$router.push({name: 'Error'});
                }   
                         
            } 
            catch(e){
                await axios.post(process.env.VUE_APP_ERROR, {"system": "Work Orders", "message": e.message, "email": 'none'}) 
                this.$router.push({name: 'Error'});
            }
        },
        async submitData() {
            try {
                this.loading = true   
                await axios.post(process.env.VUE_APP_APIPOSTWO, this.form)
                this.show = false
                this.submitted = true  
                //console.log(JSON.stringify(this.form))
            } 
            catch(e) {
                await axios.post(process.env.VUE_APP_ERROR, {"system": "Work Orders", "message": e.message, "email": 'none'}) 
                this.$router.push({name: 'ApplicationError'});
            }
            this.clearForm(); 

            

        }
    },
    created() {
        
        let path = window.location.href
        this.resid = path.substring(path.lastIndexOf('/') + 1)
        this.loadData();

    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 0px;
}
a {
  color: #42b983;
}
.lbl {
    display: block;
    text-align: right;
    line-height:1.6;
    margin-bottom:2px;
    height: 100%;
    color: #416279;
    font-weight: 600;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14pt
}
body {
  background-color: #C4E1F0 !important;
}
.other {
    height: 100vh; 
    display: flex;
    justify-content: center;
    align-items: center;  
    color:#416279; 
    font-size:14pt;
}
</style>